import React from 'react';
interface ListicleSectionProps {
  number: number;
  title: string;
  description: string;
  imagePosition?: 'left' | 'right';
  imageUrl?: string;
}
export function ListicleSection({
  number,
  title,
  description,
  imagePosition = 'left',
  imageUrl = 'https://cdn.magicpatterns.com/uploads/jSGkL5oZr6G5PH539Mcvpi/hf_20260222_190501_53c4b4d0-1b00-49c6-85ef-0b17882583ec.png'
}: ListicleSectionProps) {
  const content = <>
      {/* Image */}
      <div className="w-full lg:w-1/2 flex items-center" data-id="element-154">
        <img src={imageUrl} alt="Diagram showing how 650nm red light reawakens dormant hair follicles and activates cell growth" className="w-full h-auto rounded-xl shadow-lg scale-110" data-id="element-155" />
      </div>

      {/* Content */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center" data-id="element-156">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-brand-red text-white rounded-full font-bold text-xl mb-4" data-id="element-157">
          {number}
        </div>
        <h3 className="text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-158">
          {title}
        </h3>
        <p className="text-lg text-gray-700 leading-relaxed" data-id="element-159">{description}</p>
      </div>
    </>;
  return <div className="w-full py-16 px-4 border-b border-gray-200 last:border-b-0" data-id="element-160">
      <div className="max-w-7xl mx-auto" data-id="element-161">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${imagePosition === 'right' ? 'lg:flex-row-reverse' : ''}`} data-id="element-162">
          {imagePosition === 'right' ? <>
              <div className="w-full lg:w-1/2 flex flex-col justify-center order-2 lg:order-1" data-id="element-163">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-brand-red text-white rounded-full font-bold text-xl mb-4" data-id="element-164">
                  {number}
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-165">
                  {title}
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-166">
                  {description}
                </p>
              </div>
              <div className="w-full lg:w-1/2 order-1 lg:order-2 flex items-center" data-id="element-167">
                <img src={imageUrl} alt="Diagram showing how 650nm red light reawakens dormant hair follicles and activates cell growth" className="w-full h-auto rounded-xl shadow-lg scale-110" data-id="element-168" />
              </div>
            </> : content}
        </div>
      </div>
    </div>;
}